import GatewayService from '@/service/gateway-service';
import { PRODUCT_IMAGES } from '@/components/account/recommendations/gql';
import AwsCloudGateway from '@/gateway/AwsCloud';

export default class RecommendationsUtils {
  static async getRecommendations(userId) {
    const recommendationsResponse =
      await AwsCloudGateway.getProductRecommendations(userId);

    const recommendations = recommendationsResponse.recommendations;

    const recommendationsPromise = recommendations.map(async (item) => {
      const productsWithImages = item.products.map(async (product) => {
        const { productByHandle } =
          await RecommendationsUtils.getImages(product);
        return {
          handle: product,
          image: productByHandle.images?.edges?.[0]?.node?.url
        };
      });

      const products = await Promise.all(productsWithImages);

      return {
        ...item,
        products
      };
    });

    return Promise.all(recommendationsPromise);
  }
  static async getImages(handle) {
    return await GatewayService.getStoreFront().getRequest({
      query: PRODUCT_IMAGES,
      variables: { handle: handle }
    });
  }
}
